import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { RouterOutlet } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule, MatFabButton } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { TechnicianApiService } from '@app/core/services/api/user/technician/technician-api.service';
import { Technician } from '@app/core/interfaces/technician';
import { ApiResponse } from '@app/core/interfaces/response';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule, 
    MatCardModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatFabButton,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  // Counts for cards
  operatorCount: number = 0;
  technicianCount: number = 0;

  // Loading states
  isLoading: boolean = true;
  errorKey: string | null = null;

  constructor(
    private technicianService: TechnicianApiService
  ) {}

  ngOnInit(): void {
    this.loadDashboardData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadDashboardData(): void {
    this.isLoading = true;
    this.errorKey = null;

    this.loadTechnicianCount();

    // TODO: Load operators count - need API endpoint
    // For now, set a placeholder
    this.operatorCount = 0; // Replace with actual API call
  }

  private loadTechnicianCount(): void {
    this.technicianService.get_technicians_list_data()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: ApiResponse<Technician[]>) => {
          this.technicianCount = response.data?.length || 0;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error loading technicians:', err);
          this.errorKey = 'dashboard.error_load_technicians';
          this.isLoading = false;
        }
      });
  }

  refreshData(): void {
    this.loadDashboardData();
  }
}
